import React, { useEffect, useState } from "react";
import { ReactComponent as LiaisonOfficer } from "../../assets/images/svg/liaisonOfficer.svg";
import mail from "../../assets/images/svg/mail.svg";
import phone from "../../assets/images/svg/phone.svg";
import Header from "../../components/Header/Header";
import { observer } from "mobx-react";
import SelectNuvama from "../../components/SelectNuvama/SelectNuvama";
import downArrowBlack from "../../assets/images/svg/downArrowBlack.svg";
import UserStore from "../../store/UserStore";
import HomeModals from "../../components/HomeModals/HomeModals";
import { homePageRoute } from "../../utils/constants";
import PageHeading from "../../components/PageHeading/PageHeading";
const NoInvestment = observer(() => {
  const [rmMangaerDetails, setRmMangaerDetails] = useState([]);

  const connectData = UserStore.connectData;

  const handleWealth = () => {
    UserStore.populateHomeScreen();
  };

  useEffect(() => {
    if (UserStore.connectData?.length) {
      const connectData = UserStore.connectData?.filter(
        (eachData) => eachData?.role === "RM",
      );
      setRmMangaerDetails(connectData);
    }
  }, [connectData]);

  return (
    <div>
      <Header type={homePageRoute} />
      <div
        style={{
          background:
            "linear-gradient(0deg, rgba(221, 226, 235, 0.4705882353) 17.61%, rgba(221, 226, 235, 0) 83%)",
        }}
      >
        <div
          style={{
            maxWidth: "1440px",
            padding: "30px",
            margin: "auto",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "end",
            }}
          >
            <SelectNuvama
              type={"onlybtn"}
              memberDropdownClass="analytics-members-dropdown"
              memberDropdownTextClass="analytics-members-dropdown-text"
              downArrowIcon={downArrowBlack}
              handleWealth={(title) => handleWealth(title)}
              page="home"
            />
          </div>
          <div className="no_investment_main">
            <div className="no_investment_inside">
              <div className="liaison_officer">
                <LiaisonOfficer />
              </div>
              <PageHeading
                headingClass="no_investment_title"
                headingText="You currently have no investments with us"
              />
              <div className="no_investment_comment">
                {
                  "Get in touch with your Relationship Manager to start investing"
                }
              </div>
              {rmMangaerDetails.length ? (
                <div className="relationship_manager_contact">
                  {UserStore.connectImages?.[rmMangaerDetails?.[0]?.id] ? (
                    <img
                      style={{
                        height: "55px",
                        width: "55px",
                        borderRadius: "20px",
                      }}
                      className="manager_img"
                      src={UserStore.connectImages?.[rmMangaerDetails?.[0]?.id]}
                      alt="manager"
                    />
                  ) : (
                    <span className="profileImageDefault2">
                      {rmMangaerDetails?.[0]?.name
                        ?.split(" ")
                        .map((e) => e[0])
                        ?.join("")}
                    </span>
                  )}
                  <div className="manager_data">
                    <div className="titles">
                      <h2 className="managers_name">
                        {rmMangaerDetails?.[0]?.name}
                      </h2>{" "}
                      <h3 className="managers_position">
                        Relationship Manager
                      </h3>
                    </div>
                    <div className="contacts">
                      <img className="phone_img" src={phone} alt="phone" />{" "}
                      <h3 className="phone_no">
                        {rmMangaerDetails?.[0]?.contactNo}
                      </h3>
                    </div>
                  </div>
                  <a href={`mailto:${rmMangaerDetails?.[0]?.emailId}`}>
                    <img className="mail_icon" src={mail} alt="mailIcon" />
                  </a>
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
      </div>
      <HomeModals />
    </div>
  );
});

export default NoInvestment;
